import { API_BASE } from './config';
import { SB_SESSION, ensureFreshToken } from './auth';

/** Apply a revision from server; returns true if a reload was requested. */
export function applySyncRevision(revision, syncRevisionRef, onReload) {
  const rev = Number(revision);
  if (!Number.isFinite(rev)) return false;
  if (syncRevisionRef.current == null) {
    syncRevisionRef.current = rev;
    return false;
  }
  if (rev === syncRevisionRef.current) return false;
  syncRevisionRef.current = rev;
  onReload();
  return true;
}

/**
 * Live SSE connection — pushes revision bumps to all logged-in sessions instantly.
 * Falls back to caller's interval poll if the stream drops.
 */
export function connectPortalSync({ syncRevisionRef, onReload, onNotifications, onConnected, onDisconnected }) {
  let es = null;
  let reconnectTimer = null;
  let closed = false;

  const connect = async () => {
    if (closed) return;
    await ensureFreshToken();
    const token = SB_SESSION?.access_token;
    if (!token) {
      onDisconnected?.();
      return;
    }

    es?.close();
    const url = `${API_BASE}/dashboard/sync-stream?token=${encodeURIComponent(token)}`;
    es = new EventSource(url);

    es.onopen = () => onConnected?.();

    es.onmessage = (ev) => {
      try {
        const msg = JSON.parse(ev.data);
        if (msg.type === 'notifications') {
          onNotifications?.();
          return;
        }
        applySyncRevision(msg.revision, syncRevisionRef, onReload);
      } catch { /* ignore malformed */ }
    };

    es.onerror = () => {
      es?.close();
      es = null;
      onDisconnected?.();
      if (!closed) {
        clearTimeout(reconnectTimer);
        reconnectTimer = setTimeout(connect, 2000);
      }
    };
  };

  connect();

  return () => {
    closed = true;
    clearTimeout(reconnectTimer);
    es?.close();
    es = null;
  };
}
